import { Link } from 'react-router-dom';

import Typography from '@mui/material/Typography';
import MuiBreadcrumbs from '@mui/material/Breadcrumbs';
import MuiLink from '@mui/material/Link';

import { EMPTY_OBJECT } from '@e-socna/empty';

import { PATH_HOME } from '../app/constants/paths.constant';

export interface BreadcrumbPath {
  readonly key: string;
  readonly to?: string;
  readonly label: string;
}

interface Props {
  readonly paths: readonly BreadcrumbPath[];
}

export const Breadcrumbs = ({ paths }: Readonly<Props>) => {
  const pathsWithRoot = [
    { key: 'root', to: PATH_HOME, label: 'e-SOCNA' },
    ...paths,
  ];

  return (
    <div role="presentation">
      <MuiBreadcrumbs aria-label="breadcrumb">
        {pathsWithRoot.map(({ to, key, label }, index) =>
          index === pathsWithRoot.length - 1 ? (
            <Typography color="text.primary" key={key}>
              {label}
            </Typography>
          ) : (
            <MuiLink
              color="inherit"
              key={key}
              underline="hover"
              // eslint-disable-next-line react/jsx-props-no-spreading
              {...(to ? { component: Link, to } : EMPTY_OBJECT)}
            >
              {label}
            </MuiLink>
          ),
        )}
      </MuiBreadcrumbs>
    </div>
  );
};
